import { FC } from 'react';
import DOMPurify from 'dompurify';
import { Divider } from '@components/divider';
import { Global } from '@shared/styles/GlobalStyle';
import { CookingContainer, Title } from './Cooking.style';
interface Props {
  content: string;
}
const Cooking: FC<Props> = ({
  content
}: Props) => {
  return <CookingContainer>
            <Title>วิธีการปรุง</Title>
            <Divider />
            <Global.WysiwygContent className="content" dangerouslySetInnerHTML={{
      __html: DOMPurify.sanitize(content)
    }} />
        </CookingContainer>;
};
export default Cooking;